export default __webpack_public_path__ + "static/media/takeflight_logo.a2c7a29f.png";